import axiosRequest from "../universal/axiosService";
import { WORKFORCE_API_URL } from "../../apiConfig";

export const quickBooksApi = async ({ method, entity, body, params }) => {
  return await axiosRequest({
    method,
    url: `${WORKFORCE_API_URL}/qb/${entity}`,
    data: body,
    params,
  });
};
